// Shared helpers for the /map surface navigation + city matching.

/**
 * Case- and punctuation-insensitive city comparison so URL slugs round-trip:
 * "Winston-Salem" === "winston salem" === "winston-salem".
 */
export function cityMatches(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  const norm = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, '');
  return norm(a) === norm(b);
}

/** Lowercase, spaces→hyphens — for building /map/:state/:city URLs. */
export function citySlug(city: string): string {
  return city.toLowerCase().trim().replace(/\s+/g, '-');
}

/**
 * Preserve the active ?scenario= param across map navigations. Reads the live
 * URL (window.location.search) so components/hooks don't need API changes.
 */
export function withScenario(path: string): string {
  if (typeof window === 'undefined') return path;
  const scenario = new URLSearchParams(window.location.search).get('scenario');
  if (!scenario) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}scenario=${encodeURIComponent(scenario)}`;
}
